// @ts-nocheck
"use client";

import Script from "next/script";

export default function GoogleAnalytics() {
  return (
    <Script
      id="googleAnalytics"
      src="https://www.googletagmanager.com/gtag/js?id=G-F6NCZXPDVG"
      async
      onReady={() => {
        window.dataLayer = window.dataLayer || [];
        function gtag() {
          // eslint-disable-next-line prefer-rest-params
          dataLayer.push(arguments);
        }
        gtag("js", new Date());

        gtag("config", "G-F6NCZXPDVG");
      }}
    />
  );
}
